<footer class="footer">
  <div class="footer-container">

    <div class="footer-column">
      <h3>Suporte</h3>

      <a href="#contato">Fale Conosco</a>
      <a href="https://www.google.com/maps/place/Para%C3%ADso+do+Cerrado/data=!4m2!3m1!1s0x0:0x1024103b695b8bd1?sa=X&ved=1t:2428&ictx=111">Localização</a>
    </div>

    <div class="footer-column">
      <h3>Empresa</h3>

      <a href="#privacidade">Política de Privacidade</a>
      <a href="#termos">Termos de Uso</a>
    </div>

    <div class="footer-column social-column">
      <h3>Social</h3>

      <div class="social-links">

        <a href="https://www.facebook.com/people/Para%C3%ADso-do-Cerrado/61562009534177/" aria-label="Facebook">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M14 8h3V5h-3c-2.2 0-4 1.8-4 4v2H7v3h3v5h3v-5h3l1-3h-4V9c0-.6.4-1 1-1Z"/>
          </svg>
        </a>

        <a href="https://www.instagram.com/paraisodocerradoo/" aria-label="Instagram">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="4" y="4" width="16" height="16" rx="4"
                  fill="none" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="12" r="3.5"
                    fill="none" stroke="currentColor" stroke-width="2"/>
            <circle cx="17.5" cy="6.5" r="1"
                    fill="currentColor"/>
          </svg>
        </a>

        <a href="https://www.tiktok.com/@paraisodocerrado" aria-label="TikTok">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 4c.3 2.1 1.5 3.5 3.5 4v3
                     c-1.3 0-2.5-.4-3.5-1v5.5
                     A5.5 5.5 0 1 1 10 10v3
                     a2.5 2.5 0 1 0 2 2.5V4h3Z"/>
          </svg>
        </a>

      </div>
    </div>

    <div class="footer-logo">
      <img
        href="/"
        src="/LogoBranca.svg"
        alt="Paraíso do Cerrado"
      >
    </div>

  </div>

  <div class="footer-bottom">
    <p>© Copyright Paraíso do Cerrado 2026</p>
  </div>
</footer>
